import React, { useEffect, useState, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import theme from '../../../_shared/themes/tradeRev/theme';
import {
  ODOMETER,
  MILEAGE,
  FilterType
} from '../../../_shared/constants/filters';
import { FilterContext } from '../internal';

import { StyledOdometerFilter, StyledFilterHeader } from './Styles';
import { SliderLabel, SliderValues } from '../Filter/Styles';

const step = 5000;

const OdometerFilter = () => {
  const {
    filterMetaData: { mileageRange },
    updateFilter
  } = useContext(FilterContext);

  const maxDisplayDistance = ODOMETER.max - step;

  const [odometerDisplay, setOdometerDisplay] = useState({
    start: mileageRange.start,
    end: mileageRange.end >= ODOMETER.max ? ODOMETER.max : mileageRange.end
  });
  const [isEditing, setIsEditing] = useState(false);

  const applyFilter = (start, end) => {
    updateFilter({ start, end }, FilterType.MileageRange);
  };

  useEffect(() => {
    setOdometerDisplay({
      start: mileageRange.start,
      end: mileageRange.end >= ODOMETER.max ? ODOMETER.max : mileageRange.end
    });
    const odometerFilterSlider = document.getElementById(
      'odometer-filter-slider'
    );
    const odometerSliderEle = odometerFilterSlider?.firstElementChild?.getElementsByClassName(
      'rc-slider-handle'
    );
    if (odometerSliderEle.length > 0) {
      odometerSliderEle[0].setAttribute('data-testid', 'odometer-filter-start');
      odometerSliderEle[1].setAttribute('data-testid', 'odometer-filter-end');
    }
  }, [mileageRange]);

  useEffect(() => {
    if (
      odometerDisplay.start > ODOMETER.min ||
      odometerDisplay.end < ODOMETER.max
    ) {
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  }, [odometerDisplay, setIsEditing]);

  return (
    <StyledOdometerFilter data-testid="odometer-filter">
      <StyledFilterHeader>
        <SliderLabel isEditing={isEditing}>
          {/* Odometer */}
          <FormattedMessage id="tr5.odometer" />
        </SliderLabel>
        <SliderValues
          isEditing={isEditing}
          data-testid="odometer-filter-values"
        >
          {`${odometerDisplay.start}-`}
          {odometerDisplay.end === ODOMETER.max
            ? `${maxDisplayDistance}+`
            : odometerDisplay.end}{' '}
          km
        </SliderValues>
      </StyledFilterHeader>
      <div id="odometer-filter-slider" data-testid="odometer-filter-slider">
        <Range
          allowCross={false}
          defaultValue={[ODOMETER.min, ODOMETER.max]}
          value={[odometerDisplay.start, odometerDisplay.end]}
          min={ODOMETER.min}
          max={ODOMETER.max}
          step={step}
          onChange={([start, end]) => {
            if (end - start >= step) {
              setOdometerDisplay({ start, end });
            }
          }}
          onAfterChange={([start, end]) => {
            const computedStart = start;
            const computedEnd = end === ODOMETER.max ? MILEAGE.max : end;

            applyFilter(computedStart, computedEnd);
          }}
          railStyle={{
            backgroundColor: theme.COLORS.BASE_INVERTED,
            height: '2px'
          }}
          trackStyle={[
            {
              backgroundColor: theme.COLORS.TERTIARY
            }
          ]}
          handleStyle={[
            {
              border: `2px solid ${theme.COLORS.BASE_INVERTED}`
            },
            {
              border: `2px solid ${theme.COLORS.BASE_INVERTED}`
            }
          ]}
        />
      </div>
    </StyledOdometerFilter>
  );
};

export default OdometerFilter;
